module.exports = __webpack_public_path__ + "static/media/Cardinal.f8a3944d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/Cardinal.png
// module id = 47
// module chunks = 0